// Variant resolver. Consumers always import this — the right skin is
// chosen at runtime from the active industry. Unknown industries fall back
// to the default skin.
//
// Same pattern is used for ProductCard, Hero, CategoryTile, Footer, etc.
import { useIndustry } from '@/app/providers/industry-context.js';
import HeaderDefault from './Header.default.jsx';
import HeaderDemo from './Header.demo.jsx';
import HeaderFish from './Header.fish.jsx';
import HeaderGrocery from './Header.grocery.jsx';
import HeaderMeat from './Header.meat.jsx';
import HeaderRestaurant from './Header.restaurant.jsx';
import HeaderPet from './Header.pet.jsx';
import HeaderCoffee from './Header.coffee.jsx';

const registry = {
  default: HeaderDefault,
  demo: HeaderDemo,
  fish: HeaderFish,
  grocery: HeaderGrocery,
  meat: HeaderMeat,
  restaurant: HeaderRestaurant,
  pet: HeaderPet,
  coffee: HeaderCoffee,
};

export default function Header(props) {
  const { key } = useIndustry();
  const Component = registry[key] ?? registry.default;
  return <Component {...props} />;
}
